"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mask = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MaskMixin = require("../../mixins/components/MaskMixin");
/**
 * @related ['Modal']
 * @since 5.0.0
 */

var Mask = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Mask",
  componentId: "c11n-8-107-0__sc-1lyx31t-0"
})(["", ""], _MaskMixin.MaskMixin);
exports.Mask = Mask;
Mask.displayName = 'Mask';
Mask.propTypes = {
  /**
   * The mask is enabled by default, but you can disable it by setting this to false.
   * This can be used for blocking content until somebody takes an action.
   */
  enabled: _propTypes.default.bool
};
Mask.defaultProps = {
  enabled: true
};

/** @component */